module.exports = __webpack_public_path__ + "media/images/top/common/img_feature03-f60f68a57afa2645ffa712a4951e9c96.png";